import React from 'react';
import { StoreConfigContextProvider, BlocksContextProvider } from '/src/providers';
import Config from './config';
import './fonts.css';
import './styles.scss';

const Root = () => (
    <StoreConfigContextProvider>
        <BlocksContextProvider>
            <Config />
        </BlocksContextProvider>
    </StoreConfigContextProvider>
);

export default Root;
